import React from "react";
import "./Group256.css";

function Group256(props) {
  const { className } = props;

  return (
    <div className={`group-256-1 ${className || ""}`}>
      <div className="ellipse-25"></div>
      <div className="ellipse-26-1"></div>
      <div className="ellipse-27-1"></div>
    </div>
  );
}

export default Group256;
